import authAxios from '@services/authAxios';

const fetchResyncData = async (params) => {
    const { data } = await authAxios({
        method: 'GET',
        url: `/api/v1/sellout/sync-pos?${params}`,
    });
    return data;
};

export default fetchResyncData;
